export var OrderType;
(function (OrderType) {
    OrderType["MARKET"] = "MARKET";
    OrderType["LIMIT"] = "LIMIT";
    OrderType["STOP_LOSS"] = "STOP_LOSS";
    OrderType["STOP_LOSS_MARKET"] = "STOP_LOSS_MARKET";
})(OrderType || (OrderType = {}));
export var PositionType;
(function (PositionType) {
    PositionType["LONG"] = "LONG";
    PositionType["SHORT"] = "SHORT";
})(PositionType || (PositionType = {}));
export var ValidityType;
(function (ValidityType) {
    ValidityType["DAY"] = "DAY";
    ValidityType["IOC"] = "IOC";
})(ValidityType || (ValidityType = {}));
export var ProductType;
(function (ProductType) {
    ProductType["INTRADAY"] = "INTRADAY";
    ProductType["DELIVERY"] = "DELIVERY";
    ProductType["POSITIONAL"] = "POSITIONAL";
})(ProductType || (ProductType = {}));
export var TransactionType;
(function (TransactionType) {
    TransactionType["BUY"] = "BUY";
    TransactionType["SELL"] = "SELL";
})(TransactionType || (TransactionType = {}));
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["PENDING"] = "PENDING";
    OrderStatus["OPEN"] = "OPEN";
    OrderStatus["COMPLETED"] = "COMPLETED";
    OrderStatus["CANCELLED"] = "CANCELLED";
    OrderStatus["REJECTED"] = "REJECTED";
})(OrderStatus || (OrderStatus = {}));
//# sourceMappingURL=broker.js.map